import { CareersCategory, CareersCities, CareersTypes } from 'services/careers/types';
import { FilterListItem } from 'components/structures/careers/FilterItem';

export const categoriesToItems = (categories: CareersCategory[]): FilterListItem[] =>
  categories.map((category) => ({ label: category.title, count: category.u1_careers.length, id: category.id }));

export const citiesToItems = (cities: CareersCities[]): FilterListItem[] =>
  cities.map((city) => ({ label: `${city.name}, ${city.state.short_name}`, count: city.u1_careers.length, id: city.id }));

export const typesToItems = (types: CareersTypes[]): FilterListItem[] =>
  types.map((type) => ({ label: type.name, count: type.u1_careers.length, id: type.id }));
